module.exports = ".answer {\r\n    margin: 1em;\r\n}\r\n\r\ninput,\r\nbutton {\r\n    margin: 1em 0;\r\n}\r\n\r\ninput {\r\n    width: 250px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/styles/answer.css
// module id = ./src/styles/answer.css
// module chunks = main